function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
export var POST_BROKERFOLLOWER_REQUEST = "POST_BROKERFOLLOWER_REQUEST";
export var POST_BROKERFOLLOWER_SUCCESS = "POST_BROKERFOLLOWER_SUCCESS";
export var POST_BROKERFOLLOWER_FAILURE = "POST_BROKERFOLLOWER_FAILURE";
export var RESET_POST_BROKERFOLLOWER = "RESET_POST_BROKERFOLLOWER";
export var postBrokerFollower = function postBrokerFollower(brokerFollower) {
  return function (dispatch, getState) {
    var endpoint = "brokerFollowers";
    if (brokerFollower.id) endpoint += "/".concat(brokerFollower.id);
    return dispatch(_defineProperty({
      brokerFollower: brokerFollower
    }, CALL_API, {
      types: [POST_BROKERFOLLOWER_REQUEST, POST_BROKERFOLLOWER_SUCCESS, POST_BROKERFOLLOWER_FAILURE],
      endpoint: endpoint,
      init: {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(brokerFollower),
        credentials: "same-origin"
      }
    }));
  };
};
export var DELETE_BROKERFOLLOWER_REQUEST = "DELETE_BROKERFOLLOWER_REQUEST";
export var DELETE_BROKERFOLLOWER_SUCCESS = "DELETE_BROKERFOLLOWER_SUCCESS";
export var DELETE_BROKERFOLLOWER_FAILURE = "DELETE_BROKERFOLLOWER_FAILURE";
export var RESET_DELETE_BROKERFOLLOWER = "RESET_DELETE_BROKERFOLLOWER";
export var deleteBrokerFollower = function deleteBrokerFollower(brokerFollower) {
  return function (dispatch, getState) {
    return dispatch(_defineProperty({
      brokerFollower: brokerFollower
    }, CALL_API, {
      types: [DELETE_BROKERFOLLOWER_REQUEST, DELETE_BROKERFOLLOWER_SUCCESS, DELETE_BROKERFOLLOWER_FAILURE],
      endpoint: "brokerFollowers/".concat(brokerFollower.id),
      init: {
        method: "DELETE",
        credentials: "same-origin"
      }
    }));
  };
};